<template>
  <iMineTemplate :pageTitle="pageTitle" :activedParentKey="activedParentKey" :activedKey="activedKey" helpCenter @handleNav="handleNav">
    <template slot="rightContent">
      <div class="center pl20 pr20" v-if="info">
        <van-cell :title="info.Title" title-class="f18 c222 text-left" class="pt20 pl0 pb20 pr0 border-b" center :border="false" />
        <div v-html="info.Content" class="text-left" />
      </div>
    </template>
  </iMineTemplate>
</template>

<script>
  import { BaseMixin } from "../../../mixins/BaseMixin";
  import { LinkTypeCode } from '@/dictionary/base';
  export default {
    name: "HelpCenter",
    mixins: [BaseMixin],
    data() {
      return {
        pageTitle: ["交易管理", "帮助中心"],
        activedParentKey: 4,
        activedKey: 41,
        Id: "3e440c62-8c0b-49dc-507c-08d811cf9ba3",
        info: null
      };
    },
    watch: {
      '$route': function (to, from) {
        var need = false;
        if (this.$route.query.activedParentKey != this.activedParentKey) {
          need = true;
          this.activedParentKey = Number(this.$route.query.activedParentKey || 4);
        }
        if (this.$route.query.activedKey != this.activedKey) {
          need = true;
          this.activedKey = Number(this.$route.query.activedKey || 41);
        }
        if (this.$route.query.Id != this.Id) {
          need = true;
          this.Id = this.$route.query.Id || '3e440c62-8c0b-49dc-507c-08d811cf9ba3';
        }
        if (need) {
          this.getData(this.Id);
        }
      }
    },
    created() {},
    mounted() {
      if (this.$route.query) {
        this.activedParentKey = Number(this.$route.query.activedParentKey || 4);
        this.activedKey = Number(this.$route.query.activedKey || 41);
        this.Id = this.$route.query.Id || '3e440c62-8c0b-49dc-507c-08d811cf9ba3';
      }
      this.getData(this.Id);
    },
    methods: {
      handleNav(item, v) {
        this.$router.push({ name: LinkTypeCode.HelpCenter, query: { activedParentKey: item.key, activedKey: v.key, Id: v.id } });
      },
      getData(Id) {
        this.$hys.openLoading();
        const res = this.getAction("/api_basedata/ArticleManager/Detail", { id: Id }).then(res => {
          this.$hys.clearLoading();
          if (!res.IsSuccess) {
            this.$toast({ position: "bottom", message: res.Msg });
            return;
          }
          if (res.Data) this.info = res.Data;
        });
      }
    }
  };
</script>

<style scoped lang="less">
  .center {
    width: 940px;
    min-height: 961px;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    border: 1px solid rgba(232, 232, 232, 1);
    margin-left: 20px;
  }

  /deep/.van-col {
    padding-left: 0;
  }
</style>